import { Injector, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { ClientSearchModule } from '@roosevelt/client-ui-lib';
import { FindMemberModule, MemberSearchModule } from '@roosevelt/elig-ui-lib';
import { ButtonModule } from '@roosevelt/common-ui-lib/button';
import { CheckboxModule } from '@roosevelt/common-ui-lib/checkbox';
import { DialogModule } from '@roosevelt/common-ui-lib/dialog';
import { InputModule } from '@roosevelt/common-ui-lib/input';
import { LoaderModule } from '@roosevelt/common-ui-lib/loader';
import { Lux } from '@roosevelt/common-ui-lib/core';
import { SelectModule } from '@roosevelt/common-ui-lib/select';
import { ManageEligibilityComponent } from './manage-eligibility.component';
import { ManageEligibilityContainer } from './manage-eligibility.container';
import { IMassActionState, initialMassActionState } from '../store/massActions/state';
import { IMemberState, initialMemberState } from '../store/member/state';
import { syncLuxSliceToStorage } from '../shared/lux-storage-sync';

@NgModule({
  declarations: [
    ManageEligibilityContainer,
    ManageEligibilityComponent,
  ],
  imports: [
    CommonModule,
    SelectModule,
    FormsModule,
    MemberSearchModule,
    ReactiveFormsModule,
    CheckboxModule,
    ButtonModule,
    DialogModule,
    LoaderModule,
    InputModule,
    ClientSearchModule,
    RouterModule,
    FindMemberModule,
  ]
})
export class ManageEligibilityModule {
  constructor(lux: Lux<{ massAction: IMassActionState, member: IMemberState }>, injector: Injector) {
    const msState = JSON.parse(sessionStorage.getItem('mass-action-state') || 'null');
    const memberState = JSON.parse(sessionStorage.getItem('member-state') || 'null');
    lux.register('massAction', msState || initialMassActionState);
    lux.register('member', memberState || initialMemberState);
    syncLuxSliceToStorage(lux, injector, sessionStorage, 'mass-action-state', state => state.massAction);
    syncLuxSliceToStorage(lux, injector, sessionStorage, 'member-state', state => state.member);
  }
}
